import base from "@/store/utils/api-route/base";

const TRAINING_BASE = `${base.masterData}training/`;
const api = {
  getDataDetailOwner: `${base.meta}data_detail_owner`,
  getListJenisTraining: `${base.masterData}training/list_jenis_training`,
  getDetailJenisTraining: `${base.masterData}training/detail_jenis_training`,
  postTrainingCreate: `${base.masterData}training/create`,
  getDataJadwalExist: `${base.masterData}training/list_jadwal_exist`,
  getRiwayatListTraining: `${base.masterData}training/list_riwayat_training`,
  getListAkunKeuangan: `${base.masterData}training/list_keuangan_akun`,
  getUnavailableJadwal: `${base.masterData}training/get_unavailable_jadwal`,
  getDataDetailTraining: `${base.masterData}training/detail_training`,
  postDataUlasan: `${base.masterData}training/ulasan_training`,
  getListTraining: `${base.masterData}training/list_riwayat_training`,
  getDataJadwalRescedule: `${base.masterData}training/list_jadwal_exist`,
  postDataRescedule: `${base.masterData}training/reschedule_training`,
  getDetailPembayaran: `${base.masterData}training/detail_pembayaran_training`,
  getDataJadwalUnavailable: `${base.masterData}training/get_unavailable_jadwal`,
  getInformasiTagihan: `${base.masterData}training/informasi_tagihan`,
  postPromo: `${base.masterData}training/cek_promo`,
};

export default api;
